import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import { AppBarWithButtons } from '../../../../components/designe/app-bars/app-bar-with-action-buttons/AppBarWithButtons';
import AppSwitchWithLabel from '../../../../components/designe/app-switch-with-label/AppSwitchWithLabel';
import { useStyles } from './PublishExerciseModal.style';

interface ISavedProgramSetProps {
  onCancel: () => void;
  onSubmitCopyExercise: (canCopy) => void;
}

export default function PublishExerciseModal(props: ISavedProgramSetProps) {
  const { onCancel, onSubmitCopyExercise } = props;
  const [canCopy, setCanCopy] = useState(false);
  const { t } = useTranslation();
  const theme = useTheme();
  const { classes } = useStyles(theme);

  return (
    <div className={classes.savedProgramSetWrapper}>
      <Typography variant="text-lg">
        {t('exercises.publishExerciseMessage')}
      </Typography>
      <Box marginTop={1}>
        <AppSwitchWithLabel
          onChange={(event) => setCanCopy(event.target.checked)}
          label={t('exercises.canCopy')}
          value={canCopy}></AppSwitchWithLabel>
      </Box>

      <div className={classes.savedProgramSetBottom}>
        <AppBarWithButtons
          onClick={() => {
            onSubmitCopyExercise(canCopy);
          }}
          onCancelClick={onCancel}
        />
      </div>
    </div>
  );
}
